import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { UserSubscriptionService } from "../../services/userSubscription.service";
import { IUserSubscriptionModel } from "../../models/UserSubscription";

export const useGetUserSubscriptionQuery = (userId: string | null) => {
  return useQuery<IUserSubscriptionModel | null, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTION, userId],
    queryFn: () =>
      UserSubscriptionService.getUserSubscriptionByUserId(userId).then((res) => res.data),
    enabled: !!userId,
  });
};
